// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-toggle--disabled{opacity:.5;cursor:not-allowed;pointer-events:none}.btn-checkbox input{display:none}.btn-checkbox label{color:#fff}.btn-checkbox input:not(checked)+label{border:1px solid #fafcff;background:#7d93b2}.btn-checkbox input:checked+label:not(:hover){background-color:#104182;border:1px solid #104182}\n", ""]);
// Exports
module.exports = exports;
